/* eslint-disable class-methods-use-this, no-console */
import { AnalyticsEvent } from '../events';
import { AnalyticsLogger } from '../analyticsLogger';

export default class GTMLogger implements AnalyticsLogger {
  log(event: AnalyticsEvent): void {
    console.log('EVENT: ', event.name);
    console.log('DATA LAYER: ', event.parameters);
  }
}
